export default __webpack_public_path__ + "static/media/Contact.4499f2c2.jpg";